import { CameraScroll } from "../components/CameraScroll";
import { PartnerLogos } from "../components/PartnerLogos";
import { HeroSection } from "../components/home/HeroSection";
import { StatsSection } from "../components/home/StatsSection";
import { ServicesSection } from "../components/home/ServicesSection";
import { TalentsSection } from "../components/home/TalentsSection";
import { SelectedWorksSection } from "../components/home/SelectedWorksSection";
import { ProcessSection } from "../components/home/ProcessSection";
import { VideoPresentation } from "../components/home/VideoPresentation";
import { AboutSection } from "../components/home/AboutSection";
import { CulinairesSection } from "../components/home/CulinairesSection";
import { TestimonialsSection } from "../components/home/TestimonialsSection";
import { FaqSection } from "../components/home/FaqSection";
import { BoutiqueTeaser } from "../components/home/BoutiqueTeaser";
import { CtaSection } from "../components/home/CtaSection";
import { usePageMeta } from "../lib/i18n";

export default function Home() {
  usePageMeta({ titleKey: "meta.home.title", descKey: "meta.home.desc", path: "/" });

  return (
    <main data-testid="home-page" className="bg-ink text-bone">
      <HeroSection />
      <CameraScroll />
      <StatsSection />
      <PartnerLogos />
      <ServicesSection />
      <TalentsSection />
      <SelectedWorksSection />
      <ProcessSection />
      <VideoPresentation />
      <AboutSection />
      <CulinairesSection />
      <TestimonialsSection />
      <FaqSection />
      <BoutiqueTeaser />
      <CtaSection />
    </main>
  );
}
